import {
    ResultObj,
    allFetch
} from "../Domain";
/**
 * 車庫存 的欄位
 */
export type CarWarehouseParams = {
    cw_id: string;
    store_department: string;
    store_space: string;
    park_number_all: string;
    manage_user_id: string;
    manage_ul_id: string;
    custody_unit_id: string;
    visible: string;
}

/**
 * @description 新增新車庫存
 */
export interface CarWarehouseCreateParams {
    store_department: string;
    store_space: string;
    park_number_all: string;
    manage_user_id: string;
    manage_ul_id: string;
    custody_unit_id: string;
}
export const CarWarehouseCreate = async (params: CarWarehouseCreateParams): Promise<ResultObj> =>
    await allFetch('CarWarehouse/CarWarehouseCreate', params);

/**
 * 車倉庫查詢
 * @param {*} obj 
 * @returns 
 */
export interface CarWarehouseSearchParams {
    store_department?: string;
    store_space?: string;
    park_number_all?: string;
    manage_user_id?: string;
    manage_ul_id?: string;
    custody_unit_id?: string;
    cw_id?: string;
    visible?: string;
    page: number;
    num_per_page?: number;
}

export type CarWarehouseSearchResItem = {
    custody_unit_id: string;
    cw_id: string;
    manage_ul_id: string;
    manage_ul_name: string;
    manage_unit_name: string;
    manage_user_id: string;
    manage_user_name: string;
    park_number_all: string;
    park_number_now: string;
    park_number_remain: string;
    store_department: string;
    store_space: string;
    user_cre_time: string;
    visible: string;
}

export const CarWarehouseSearch = async (params: CarWarehouseSearchParams = {
    store_department: "",
    store_space: "",
    park_number_all: "",
    manage_user_id: "",
    manage_ul_id: "",
    custody_unit_id: "",
    cw_id: "",
    visible: "",
    page: 1,
    num_per_page: 10
}): Promise<ResultObj<CarWarehouseSearchResItem[]>> =>
    await allFetch('CarWarehouse/CarWarehouseSearch', params);

/**
 * 修改車倉庫
 * @param {*} obj 
 * @returns 
 */
export interface CarWarehouseUpdateParams {
    cw_id: string;
    store_department: string;
    store_space: string;
    park_number_all: string;
    manage_user_id: string;
    manage_ul_id: string;
    custody_unit_id: string;
    visible: string;
}
export const CarWarehouseUpdate = async (params: CarWarehouseUpdateParams): Promise<ResultObj> =>
    await allFetch('CarWarehouse/CarWarehouseUpdate', params);

